import { toast } from "react-toastify";
import { UPDATE_LOADING } from "../../redux/modules/loading";
import { createAction } from "../utils";

const GET_PAYMENT_PLAN = "plt-web/paymentPlan/GET_PAYMENT_PLAN";
const EMPTY_PAYMENT_PLAN = "plt-web/paymentPlan/EMPTY_PAYMENT_PLAN";

const initialState = {
	data: {},
	loading: false,
};

export default function reducer(state, { type, ...action }) {
	if (!state) {
		state = initialState;
	}
	switch (type) {
		case GET_PAYMENT_PLAN: {
			return { data: action.payload, loading: false };
		}
		case EMPTY_PAYMENT_PLAN: {
			return { data: {}, loading: false };
		}
		default:
			return state;
	}
}

export const emptyPaymentPlan = () => ({
	type: EMPTY_PAYMENT_PLAN,
});

export const getPaymentPlan =
	({ logError, dispatch, sendHttpRequest }) =>
	(params) => {
		const path = "v2/repayments";
		const handlePaymentPlanError = (
			errorMessage,
			requestParams,
			unhandledError = false,
		) => {
			toast.error(`Failed to retrieve payment plan: ${errorMessage}`);
			logError(
				`Error calling /api/${path}. Error: ${errorMessage}. Params: ${requestParams}. Unhandled Error: ${unhandledError}`,
			);
		};

		dispatch(createAction(UPDATE_LOADING, true));
		return sendHttpRequest(path, {
			method: "POST",
			body: JSON.stringify(params),
		})
			.then((response) => response.text())
			.then((textResponse) => JSON.parse(textResponse))
			.then((paymentPlan) => {
				if (paymentPlan.message) {
					handlePaymentPlanError(
						paymentPlan.message,
						JSON.stringify(params),
						false,
					);
				}
				dispatch(createAction(UPDATE_LOADING, false));
				dispatch(createAction(GET_PAYMENT_PLAN, paymentPlan));
				return paymentPlan;
			})
			.catch((err) => {
				handlePaymentPlanError(`${err.message}`, JSON.stringify(params), true);
				dispatch(createAction(GET_PAYMENT_PLAN, {}));
				return { message: err.message };
			});
	};
